import { useEffect } from "react";
import Navbar from "../components/Navbar/Navbar";
import "./LegalPage.css";

const LAST_UPDATED = "August 2025";
const ORG = "FORGE NGO";
const EMAIL = "info@forge.ngo";

export default function TermsOfUsePage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Navbar />
      <div className="legal">
        <div className="legal__hero">
          <div className="container-fg container-2xxl">
            <p className="legal__eyebrow">Legal</p>
            <h1 className="legal__title">Terms of Use</h1>
            <p className="legal__meta">Last updated: {LAST_UPDATED}</p>
          </div>
        </div>

        <div className="legal__body container-fg container-2xxl">
          <div className="legal__intro">
            <p>By accessing or using our website and member portal, you agree to these Terms of Use. Please read them carefully. If you do not agree, do not use our services.</p>
          </div>

          <section className="legal__section">
            <h2>1. About FORGE NGO</h2>
            <p>
              {ORG} is a registered 501(c)(3) public charity (EIN: 33-2406117) that provides transformational retreat experiences at no cost to eligible veterans, first responders, law enforcement,
              and Gold Star families. Our retreats are conducted in Colombia.
            </p>
          </section>

          <section className="legal__section">
            <h2>2. Eligibility &amp; Application</h2>
            <ul>
              <li>Retreat participation is limited to eligible individuals as defined in our application criteria.</li>
              <li>Submission of an application does not guarantee acceptance.</li>
              <li>You must provide truthful, accurate information in your application. Misrepresentation may result in immediate disqualification and permanent ban from future applications.</li>
              <li>One application per person per active application period. Duplicate applications will be rejected.</li>
            </ul>
          </section>

          <section className="legal__section">
            <h2>3. Member Portal</h2>
            <ul>
              <li>Access to the member portal is restricted to individuals with a submitted application.</li>
              <li>You are responsible for maintaining the confidentiality of your sign-in credentials.</li>
              <li>You may not share your portal access with any other person.</li>
              <li>We reserve the right to suspend or terminate portal access for misuse, including submission of false information or inappropriate communications.</li>
            </ul>
          </section>

          <section className="legal__section">
            <h2>4. Acceptable Use</h2>
            <p>You agree not to:</p>
            <ul>
              <li>Use our services for any unlawful purpose.</li>
              <li>Upload malicious files, spam, or inappropriate content.</li>
              <li>Attempt to gain unauthorised access to other users' data or our systems.</li>
              <li>Impersonate any person or organisation.</li>
              <li>Use automated tools to scrape, crawl, or harvest data from our services.</li>
            </ul>
          </section>

          <section className="legal__section">
            <h2>5. Intellectual Property</h2>
            <p>
              All content on this website — including text, images, logos, and course materials — is the property of FORGE NGO or its licensors and is protected by copyright law. You may not
              reproduce, distribute, or create derivative works without our written permission.
            </p>
            <p>
              Personal stories and community map submissions remain the property of the individual who submitted them. By submitting content, you grant FORGE NGO a non-exclusive, royalty-free licence
              to display and share it for mission-related purposes.
            </p>
          </section>

          <section className="legal__section">
            <h2>6. Course Content &amp; Learning Materials</h2>
            <p>
              Course content provided through the member portal is for personal use by accepted participants only. You may not share, resell, or redistribute course materials. Content is provided for
              informational and educational purposes and does not constitute medical, legal, or professional advice.
            </p>
          </section>

          <section className="legal__section">
            <h2>7. Disclaimer of Warranties</h2>
            <p>
              Our website and portal are provided "as is" without warranties of any kind, express or implied. We do not warrant that services will be uninterrupted, error-free, or free of viruses. We
              reserve the right to modify, suspend, or discontinue any service at any time.
            </p>
          </section>

          <section className="legal__section">
            <h2>8. Limitation of Liability</h2>
            <p>
              To the fullest extent permitted by law, FORGE NGO shall not be liable for any indirect, incidental, special, or consequential damages arising from use of our services. Our total
              liability for any claim shall not exceed the amount you have donated to us in the twelve months preceding the claim.
            </p>
          </section>

          <section className="legal__section">
            <h2>9. Governing Law</h2>
            <p>
              These terms are governed by the laws of the State of Texas, United States, without regard to conflict of law provisions. Any disputes shall be resolved in the courts of Harris County,
              Texas.
            </p>
          </section>

          <section className="legal__section">
            <h2>10. Changes to These Terms</h2>
            <p>
              We may revise these Terms at any time. Material changes will be communicated via email to registered users. Continued use of our services constitutes acceptance of the revised terms.
            </p>
          </section>

          <section className="legal__section">
            <h2>11. Contact</h2>
            <p>
              Questions about these Terms? Contact us at <a href={`mailto:${EMAIL}`}>{EMAIL}</a>.
            </p>
          </section>
        </div>
      </div>
    </>
  );
}
